var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.order,
          expression: "order",
        },
      ],
      staticClass: "c-select",
      on: {
        change: function ($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function (o) {
              return o.selected
            })
            .map(function (o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.order = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        },
      },
    },
    [
      _c(
        "option",
        {
          staticClass: "c-select__option",
          domProps: {
            value: {
              orderBy: "name",
              sortOrder: "asc",
            },
          },
        },
        [_vm._v("\n    Alfabetisk\n  ")]
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          staticClass: "c-select__option",
          domProps: {
            value: {
              orderBy: "price",
              sortOrder: "asc",
            },
          },
        },
        [_vm._v("\n    Pris (lav – høy)\n  ")]
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          staticClass: "c-select__option",
          domProps: {
            value: {
              orderBy: "price",
              sortOrder: "desc",
            },
          },
        },
        [_vm._v("\n    Pris (høy – lav)      \n  ")]
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          staticClass: "c-select__option",
          domProps: {
            value: {
              orderBy: "sortSize",
              sortOrder: "asc",
            },
          },
        },
        [_vm._v("\n    Størrelse (liten – stor)\n  ")]
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          staticClass: "c-select__option",
          domProps: {
            value: {
              orderBy: "sortSize",
              sortOrder: "desc",
            },
          },
        },
        [_vm._v("\n    Størrelse (stor – liten)\n  ")]
      ),
      _vm._v(" "),
      _c(
        "option",
        {
          staticClass: "c-select__option",
          domProps: {
            value: {
              orderBy: "bedroom_id",
              sortOrder: "asc",
            },
          },
        },
        [_vm._v("\n    Antall soverom\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }